// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"303":"f1081b06","787":"f2faebed","882":"883b15b1"}[chunkId] + ".chunk.js";
};